import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { deleteLocalData, getLocalData } from "../../helpers/localData";
import { CommonLayout, CommonLayoutProps } from "./commonLayout";

export interface PrivatePageProps extends CommonLayoutProps {}

export const PrivatePage = (props: PrivatePageProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlRedirect = getLocalData('loginRedirect')

    if (!urlRedirect) return;

    navigate(urlRedirect);
    deleteLocalData('loginRedirect')
  }, [])

  return (
    <CommonLayout {...props}/>
  )
}